import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FormRoot,
  FormSelect,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import { EXPENSE_PAYMENT_METHOD_LABELS } from "../lib/expense-format";

const MarkExpensePaidFormSchema = z.object({
  paymentMethod: z.enum(["cash", "bank_transfer", "other"]),
  notes: z.string().optional(),
});

type MarkExpensePaidFormValues = z.infer<typeof MarkExpensePaidFormSchema>;

type MarkExpensePaidDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (values: MarkExpensePaidFormValues) => Promise<void>;
  isPending?: boolean;
};

export function MarkExpensePaidDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: MarkExpensePaidDialogProps) {
  const methods = RHF.useForm<MarkExpensePaidFormValues>({
    resolver: zodResolver(MarkExpensePaidFormSchema),
    defaultValues: {
      paymentMethod: "bank_transfer",
      notes: "",
    },
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ບັນທຶກການຈ່າຍ</DialogTitle>
        </DialogHeader>
        <FormRoot
          methods={methods}
          onSubmit={async (values) => {
            await onConfirm(values);
            methods.reset();
          }}
          className="space-y-4"
        >
          <FormSelect
            name="paymentMethod"
            label="ວິທີຈ່າຍ"
            options={Object.entries(EXPENSE_PAYMENT_METHOD_LABELS).map(
              ([value, label]) => ({ value, label }),
            )}
          />
          <FormTextarea
            name="notes"
            label="ຫມາຍເຫດ"
            placeholder="ຫມາຍເຫດເພີ່ມເຕີມ (ບໍ່ບັງຄັບ)"
            rows={2}
          />
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              ຍົກເລີກ
            </Button>
            <Button type="submit" disabled={isPending}>
              ຢືນຢັນຈ່າຍ
            </Button>
          </DialogFooter>
        </FormRoot>
      </DialogContent>
    </Dialog>
  );
}
